import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Alert,
  TextField,
} from "@mui/material";
import { api } from "../services/api";

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      setStatus("error");
      setMessage("Please enter your email address");
      return;
    }

    try {
      setStatus("loading");
      await api.post("/api/auth/forgot-password", { email });
      setStatus("success");
      setMessage("Password reset instructions have been sent to your email.");
    } catch (error) {
      setStatus("error");
      setMessage("Failed to send reset instructions. Please try again.");
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Forgot Password
        </Typography>

        {status === "success" && (
          <Alert severity="success" sx={{ width: "100%" }}>
            {message}
          </Alert>
        )}

        {status === "error" && (
          <Alert severity="error" sx={{ width: "100%" }}>
            {message}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
            disabled={status === "loading" || status === "success"}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={status === "loading" || status === "success"}
          >
            {status === "loading" ? "Sending..." : "Send Reset Instructions"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
